import { raportyRoutes, otherRoutes } from "./index"
import ViewReporterHome from "../../components/views/home/reporter/ViewReporterHome.jsx";

const startRoute = {
    path: "/",
    roles: ['any'],
    exact: true,
    forbidden: true,
    view: <ViewReporterHome/>,
    mode: 'pass',
}

export const routesReporter = [
    startRoute,
    ...raportyRoutes,
    ...otherRoutes,
]


